import styles from "./DesktopSideBar.module.css"
import SideBarItem from "@components/Common/SideBarItem"

const DesktopSideBar = () => {
  return (
    <div className={styles.sideBarSection}>
      <SideBarItem
        linkClassName={styles.sideBarItem}
        linkActiveClassName={styles.linkActive}
        showText={true}
        route="/dashboard"
      />
      <SideBarItem
        linkClassName={styles.sideBarItem}
        linkActiveClassName={styles.linkActive}
        showText={true}
        route="/manage-patient-vision"
      />

      <SideBarItem
        linkClassName={styles.sideBarItem}
        linkActiveClassName={styles.linkActive}
        showText={true}
        route="/manage-appointment"
      />

      <SideBarItem
        linkClassName={styles.sideBarItem}
        linkActiveClassName={styles.linkActive}
        showText={true}
        route="/other-apps"
      />

      <SideBarItem
        linkClassName={styles.sideBarItem}
        linkActiveClassName={styles.linkActive}
        showText={true}
        route="/my-account"
      />
    </div>
  )
}

export default DesktopSideBar
